import { render, staticRenderFns } from "./AgencyLeftSection.vue?vue&type=template&id=45a66737&scoped=true"
import script from "./AgencyLeftSection.vue?vue&type=script&lang=js"
export * from "./AgencyLeftSection.vue?vue&type=script&lang=js"
import style0 from "./AgencyLeftSection.vue?vue&type=style&index=0&id=45a66737&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a66737",
  null
  
)

export default component.exports